import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  justify-content: space-between;
  margin-top: 3rem;
  width: 60vw;
`;
